import { TableCell, TableContainer } from "@material-ui/core";
import { Link } from "react-router-dom";
import styled, { FlattenSimpleInterpolation, createGlobalStyle, css } from "styled-components";
import { OrderStatus } from "../../../../models/Order";

export const BookingContentWrap = styled.div`
	    width: 1200px;
    position: relative;
    margin: 0 auto 0;
     padding: 24px 0 40px;
    max-width: 1440px;
    // display: flex;
    font-size:16px;
    justify-content: space-between;
    @media screen and (max-width: 768px) {
		margin: 0;
    width: 100%;
    padding: 0 16px 16px 16px;s
    height: inherit;
	    align-items: center;
   
}
	}
`;
export const BookingContentName = styled.div`
	color: #111827;
	font-size: 24px;
	font-weight: 600;
	line-height: 28px;
	margin-bottom: 24px;
`;

export const BookingDashboardWrap = styled.div`
	display: grid;
	grid-template-columns: minmax(0, 1.7fr) repeat(2, minmax(220px, 0.85fr));
	gap: 18px;
	margin: 0 0 28px;

	@media screen and (max-width: 1100px) {
		grid-template-columns: 1fr 1fr;
	}

	@media screen and (max-width: 768px) {
		grid-template-columns: 1fr;
	}
`;

export const BookingDashboardCard = styled.div`
	background: #ffffff;
	border: 1px solid rgba(14, 30, 64, 0.08);
	border-radius: 22px;
	padding: 20px 22px;
	box-shadow:
		0 24px 60px rgba(15, 23, 42, 0.08),
		inset 0 1px 0 rgba(255, 255, 255, 0.6);
	position: relative;
	overflow: hidden;
`;

export const BookingDashboardPrimaryCard = styled(BookingDashboardCard)`
	background:
		radial-gradient(circle at top right, rgba(26, 115, 232, 0.18), transparent 34%),
		linear-gradient(135deg, #0f172a 0%, #132c55 48%, #0f6cbd 100%);
	color: #ffffff;
	grid-row: span 2;
	min-height: 264px;

	@media screen and (max-width: 1100px) {
		grid-column: 1 / -1;
		grid-row: auto;
		min-height: 0;
	}
`;

export const BookingDashboardSecondaryCard = styled(BookingDashboardCard)`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	min-height: 123px;
	background:
		linear-gradient(180deg, rgba(255, 255, 255, 0.96) 0%, rgba(248, 250, 252, 0.98) 100%);
`;

export const BookingDashboardLabel = styled.div`
	color: #4b5563;
	font-size: 13px;
	font-weight: 600;
	margin-bottom: 10px;
	text-transform: uppercase;
	letter-spacing: 0.04em;
`;

export const BookingDashboardEyebrow = styled.div`
	display: inline-flex;
	align-items: center;
	width: max-content;
	padding: 6px 10px;
	border-radius: 999px;
	margin-bottom: 14px;
	font-size: 11px;
	font-weight: 700;
	letter-spacing: 0.08em;
	text-transform: uppercase;
	color: rgba(15, 23, 42, 0.72);
	background: rgba(15, 23, 42, 0.06);
`;

export const BookingDashboardValue = styled.div`
	color: #111827;
	font-size: 34px;
	font-weight: 700;
	line-height: 1.1;
	word-break: break-word;
`;

export const BookingDashboardPrimaryValue = styled.div`
	font-size: clamp(34px, 4vw, 52px);
	font-weight: 800;
	line-height: 1.04;
	letter-spacing: -0.04em;
	color: #ffffff;
	max-width: 16ch;
`;

export const BookingDashboardPrimaryValueSub = styled.div`
	margin-top: 12px;
	max-width: 58ch;
	font-size: 15px;
	line-height: 1.7;
	color: rgba(255, 255, 255, 0.8);
`;

export const BookingDashboardMeta = styled.div`
	color: #6b7280;
	font-size: 13px;
	line-height: 1.5;
	margin-top: 8px;
	word-break: break-word;
`;

export const BookingDashboardMetaStrong = styled.span`
	font-weight: 800;
	color: inherit;
`;

export const BookingDashboardPrimaryFooter = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 14px;
	margin-top: 22px;

	${BookingDashboardMeta} {
		margin-top: 0;
		padding: 10px 12px;
		border-radius: 14px;
		background: rgba(255, 255, 255, 0.1);
		color: rgba(255, 255, 255, 0.84);
		backdrop-filter: blur(8px);
	}
`;

export const BookingDashboardList = styled.div`
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: 10px;
	margin-top: 22px;

	@media screen and (max-width: 768px) {
		grid-template-columns: 1fr;
	}
`;

export const BookingDashboardListItem = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 12px;
	padding: 12px 14px;
	border-radius: 16px;
	background: rgba(255, 255, 255, 0.09);
	border: 1px solid rgba(255, 255, 255, 0.1);
	color: rgba(255, 255, 255, 0.82);
	font-size: 13px;

	strong {
		font-size: 14px;
		font-weight: 800;
		color: #ffffff;
		text-align: right;
	}
`;

export const BookingDashboardTrend = styled.div`
	margin-top: 12px;
	font-size: 13px;
	line-height: 1.6;
	color: #64748b;
`;

export const BookingTableBodyButton = styled.div<{ status?: number | null; loading?: boolean }>`
	display: ${({ status }) => (status === OrderStatus.Pending || status === OrderStatus.Paid ? "flex" : "none")};
	height: 32px;
	padding: 8px 8px;
	justify-content: center;
	align-items: center;
	border-radius: 8px;
	border: 1px solid #e5e7eb;
	background: #fff;
	cursor: pointer;
	color: #111827;
	margin-bottom: 4px;
	cursor: ${({ loading }) => (loading ? "not-allowed" : "pointer")};
	background: ${({ loading }) => (loading ? "#ccc" : "#fff")};
	pointer-events: ${({ loading }) => (loading ? "none" : "auto")};
`;

export const BookingTableBodyStauts = styled.div<{ status?: number | null }>`
	color: ${({ status }) =>
		status === OrderStatus.Pending
			? "#D97706"
			: status === OrderStatus.Cancel
			? "#DC2626"
			: status === OrderStatus.Paid
			? "#1250DC"
			: status === OrderStatus.Reserved
			? "#0369A1"
			: status === OrderStatus.NoShow
			? "#475569"
			: "black"};
	background-color: ${({ status }) =>
		status === OrderStatus.Pending
			? "#FEF3C7"
			: status === OrderStatus.Cancel
			? "#FEE2E2"
			: status === OrderStatus.Paid
			? "#D7E8FD"
			: status === OrderStatus.Reserved
			? "#E0F2FE"
			: status === OrderStatus.NoShow
			? "#E2E8F0"
			: "#e4e4e4"};
	padding: 4px 8px;
	border-radius: 16px;
`;
export const MyBookingWrapper = styled.div`
	background-color: #f3f4f6;
`;

export const MyBookingTableContainer = styled(TableContainer)`
	background-color: #fff;
	border-radius: 16px;
	@media screen and (max-width: 1282px) {
		display: none;
	}
`;

export const MyBookingTableContainerAdmin = styled(TableContainer)`
	background-color: #fff;
	border-radius: 16px;
	// @media screen and (max-width: 1282px) {
	// 	display: none;
	// }
`;

export const MyBookingContainerMobi = styled.div`
	display: none;
	@media screen and (max-width: 1282px) {
		display: block;
	}
`;

export const BookingMobiWrap = styled.div`
	display: none;
	@media screen and (max-width: 1282px) {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: flex-start;
		border-radius: 12px;
		background: #fff;
		box-shadow: 0px 4px 14.6px 0px rgba(0, 0, 0, 0.08);
		margin-bottom: 16px;
		font-size: 12px;
	}
`;

export const BookingTableBodyDate = styled.div`
	border-radius: 6px;
	border: 1px solid #e5e7eb;
	display: flex;
	padding: 8px;
	justify-content: center;
	align-items: center;
`;
export const BookingTableBodyDateAdmin = styled.div`
	border-radius: 6px;
	display: flex;
	justify-content: center;
	align-items: center;
	white-space: nowrap;
	width: max-content;
`;

export const AdminOrderManagementFilterItem = styled.div`
	margin-left: 8px;
	margin-right: 8px;
	min-width: 200px;
	// max-width:200px;
	@media screen and (max-width: 1282px) {
		// margin-left: 0px;
		// margin-right: 0px;
		min-width: 0px;
	}
`;
export const UserFormButtonAccept = styled.button<{ disabledButton?: boolean }>`
	text-decoration: none;
	border: 1px solid var(--primary-color);
	background-color: var(--primary-color);
	color: #fff;
	padding: 10px 40px 12px 40px;
	border-radius: 8px;
	font-size: 16px;
	line-height: 17px;
	font-weight: 600;
	margin-left: 10px;
	opacity: ${(props) => (props.disabledButton ? 0.4 : 1)};
	@media screen and (-webkit-min-device-pixel-ratio: 0) {
		padding: 10px 30px 12px 30px;
	}
`;

export const UserFormServiceButtonClose = styled(UserFormButtonAccept)`
	border-radius: 100px;
	background-color: #b6b6b6;
	border: 1px solid #b6b6b6;
	margin-left: 0px;
	margin-bottom: 10px;
	// width: calc(50% - 5px);
	margin-bottom: 10px;
`;
export const UserFormServiceButtonCreated = styled(UserFormButtonAccept)`
	border-radius: 100px;
	border: 1px solid ${(props) => (props.disabled ? "var(--primary-color-blur)" : "#7cc246")};
	// width: calc(50% - 5px);
	margin-bottom: 10px;
	background-color: ${(props) => (props.disabled ? "var(--primary-color-blur)" : "#7cc246")};
	cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
`;
export const BookingFilterWrap = styled.div`
	display: flex;
	width: 1200px;
	position: relative;
	margin: 8px auto;
	max-width: 1440px;
	@media screen and (max-width: 768px) {
		width: 100%;
		flex-direction: column;
	}
`;
export const BookingFilterWrapv2 = styled(BookingFilterWrap)`
	@media screen and (max-width: 768px) {
		flex-direction: row;
	}
`;
export const ButtonUserWrap = styled.div`
	display: flex;
	width: 1200px;
	position: relative;
	margin: 8px auto;
	max-width: 1440px;
	justify-content: flex-end;
	@media screen and (max-width: 768px) {
		width: 100%;
		// flex-direction: column;
	}
`;
export const BookingFilterButton = styled.button`
	padding: 8px 16px;
	border: navajowhite;
	border-radius: 100px;
	color: #fff;
	background: #00a1ca;
`;
export const AdminTransactionAddButtton = styled.button<{ disabled?: boolean }>`
	padding: 8px;
	background-color: var(--primary-color);
	${(props) => (props.disabled ? "background-color: #686868;" : "background-color:var(--primary-color);")}
	border: none;
	border-radius: 8px;
	color: rgb(255, 255, 255);
	margin-left: 12px;
	@media screen and (max-width: 768px) {
		bottom: 0;
	}
`;
export const BookingFilterTitle = styled.div`
	margin-bottom: 6px;
`;

export const BookingFilterSelect = styled.select`
	padding: 8px 16px;
	width: 100%;
	border-radius: 100px;
	border: 1px solid #d9e0e4;
`;
export const InputOrderAdminTitle = styled.div`
	padding: 8px 0 4px;
`;

export const OrderAdminSelectDisable = styled.div<{ updateOrder?: boolean }>`
	opacity: ${({ updateOrder }) => (updateOrder ? 0.5 : 1)};
	pointer-events: ${({ updateOrder }) => (updateOrder ? "none" : "auto")};
	cursor: ${({ updateOrder }) => (updateOrder ? "not-allowed" : "pointer")};
`;
export const PaginationWrapper = styled.div`
	margin-top: 24px;
	padding-bottom: 32px;
	text-align: center;

	@media screen and (max-width: 768px) {
		margin: 16px 0px 16px 0px;
	}
`;

export const PaginationWrapperTop = styled.div`
	text-align: center;

	@media screen and (max-width: 768px) {
		margin: 16px 0px 16px 0px;
	}
`;

export const BookingMobiTop = styled.div`
	display: flex;

	justify-content: space-between;
	align-items: center;
	width: 100%;
	padding: 8px;
	background: #f9fafb;
	border-radius: 12px 12px 0 0;
	@media screen and (max-width: 768px) {
		font-size: 13px;
		font-weight: 500;
		line-height: 18px;
	}
`;
export const BookingMobiAdressWrap = styled.div`
	display: flex;
	margin-top: 12px;
	padding: 0 8px;
`;
export const BookingMobiInnerWrap = styled.div`
	display: flex;
	margin-top: 12px;
	width: 100%;
	justify-content: space-between;
	padding: 0 8px;
`;
export const BookingMobiItemWrap = styled.div`
	display: flex;
	width: calc(50% - 8px);
`;
export const BookingMobiAdressImg = styled.img`
	width: 16px;
	height: 16px;
	margin-right: 6px;
`;
export const BookingMobiAdressContent = styled.div``;
export const BookingMobiAdressTop = styled.div`
	color: #111827;
	font-size: 14px;
	font-style: normal;
	font-weight: 600;
	line-height: 20px;
	@media screen and (max-width: 768px) {
		font-size: 12px;
		font-weight: 600;
		line-height: 16px;
		margin-bottom: 4px;
	}
`;
export const BookingMobiAdressBottom = styled.div`
	color: #111827;
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 20px;
	@media screen and (max-width: 768px) {
		font-size: 12px;
		font-weight: 400;
		line-height: 16px;
	}
`;
export const BookingMobiTimeWrap = styled.div`
	display: flex;
`;
export const BookingMobiTimeContainerWrap = styled.div`
	display: flex;
	margin-top: 12px;
	width: 100%;
	justify-content: flex-start;
	padding: 0 8px;
`;
export const Width4 = styled.div`
	width: 4px;
`;
export const Separation = styled.div<{ status?: number | null }>`
	height: 1px;
	width: 100%;
	background: #e5e7eb;
	margin: 12px 0;
	display: ${({ status }) => (status === OrderStatus.Pending || status === OrderStatus.Paid ? "flex" : "none")};
`;

export const BookingTableBodyButtonCancel = styled.div`
	width: 100%;
	padding: 0px 8px;
	display: flex;
	justify-content: flex-end;
	margin-bottom: 12px;
`;
export const TableCellFloatLeft = styled.div`
	display: flex;
	justify-content: flex-start;
	align-items: flex-start;
	width: 100%;
	min-width: 0;
`;
export const TableCellFloatLeftInner = styled.div`
	width: max-content;
	display: flex;
	font-weight: 600;
	white-space: nowrap;
	margin-right: 8px;
`;
export const TableCellFloatLeftInnerv2 = styled.div`
	flex: 1;
	min-width: 0;
	text-align: left;
	white-space: normal;
	word-break: break-word;
	overflow-wrap: anywhere;
`;
export const TableCellFloatLeftInnerUser = styled.div`
	width: 50px;
	display: flex;
	font-weight: 600;
`;
export const TableCellSmall = styled(TableCell)`
	&.MuiTableCell-root {
		padding: 8px 6px;
	}
`;
export const PartnerInnerName = styled.div`
	min-width: 135px;
	margin-bottom: 4px;
	font-weight: 600;
	width: max-content;
	margin-right: 8px;
`;

export const PartnerInnerContent = styled.div`
	flex: 1;
	word-break: break-word;
`;

export const PartnerInnerNameWWrap = styled.div`
	display: flex;
	margin-bottom: 4px;
`;

export const PartnerInnerNameFilterWWrap = styled.div`
	width: 200px;
	@media screen and (max-width: 768px) {
		width: 100%;
		padding: 0 8px;
	}
`;
